import React, { useRef, useState } from "react";
import auth from "../shared/auth";
import Errors from "./errors";
import Progress from "./progress";

const Download = (props) => {
  const { clearPdf, download, progress, downloadFile, downloadCsv, errors, className } = props;
  const [showMenu, setShowMenu] = useState(false);
  const [dropUp, setDropUp] = useState(false);
  const triggerRef = useRef<HTMLButtonElement | null>(null);
  function showFile(blob) {
    // It is necessary to create a new blob object with mime-type explicitly set
    // otherwise only Chrome works like it should
    var newBlob = new Blob([blob], { type: "application/pdf" });

    // For other browsers:
    // Create a link pointing to the ObjectURL containing the blob.
    const data = window.URL.createObjectURL(newBlob);
    var link = document.createElement("a");
    link.href = data;

    link.download = download.fileName;
    link.click();
    setTimeout(function () {
      // For Firefox it is necessary to delay revoking the ObjectURL
      window.URL.revokeObjectURL(data);
    }, 100);
  }

  if (download && !download.downloaded) {
    clearPdf();
    if (download.url) {
      fetch(download.url, {
        method: "get",
        headers: new Headers({
          Authorization: "Bearer " + auth.getToken()
        })
      })
        .then((r) => r.blob())
        .then(showFile);
    }
  }

  const url = download ? download.url + "?t=" + auth.getToken() : "";

  const showDownloadButton = !progress && !download && !download?.downloaded;

  const onPdfDownload = () => {
    setShowMenu(false);
    if (downloadFile) {
      downloadFile();
    }
  };

  const onCsvDownload = () => {
    setShowMenu(false);
    if (downloadCsv) {
      downloadCsv();
    }
  };

  const onToggleMenu = () => {
    if (!showMenu && triggerRef.current) {
      const rect = triggerRef.current.getBoundingClientRect();
      const estimatedMenuHeight = 120;
      const viewportHeight = window.innerHeight || document.documentElement.clientHeight;
      const shouldDropUp = rect.bottom + estimatedMenuHeight > viewportHeight;
      setDropUp(shouldDropUp);
    }
    setShowMenu((isOpen) => !isOpen);
  };

  return (
    <>
      <Errors errors={errors} />
      {showDownloadButton && !downloadCsv && (
        <button type="button" className={`button ${className}`} onClick={onPdfDownload}>
          Download
        </button>
      )}
      {showDownloadButton && downloadCsv && (
        <div className={`dropdown ${showMenu ? "is-active" : ""} ${dropUp ? "is-up" : ""}`} onMouseLeave={() => setShowMenu(false)}>
          <div className="dropdown-trigger">
            <button
              type="button"
              className={`button ${className}`}
              aria-haspopup="true"
              aria-controls="download-menu"
              onClick={onToggleMenu}
              ref={triggerRef}
            >
              <span>Download</span>
              <span className="icon is-small">
                <i className="material-icons">arrow_drop_down</i>
              </span>
            </button>
          </div>
          <div className="dropdown-menu" id="download-menu" role="menu">
            <div className="dropdown-content">
              <a className="dropdown-item" onClick={onPdfDownload}>
                PDF
              </a>
              <a className="dropdown-item" onClick={onCsvDownload}>
                CSV
              </a>
            </div>
          </div>
        </div>
      )}
      <Progress progress={progress}></Progress>
      {download && (
        <div>
          The file should automatically download, if not click the link below
          <br />
          <a href={url} target="_blank">
            Download
          </a>
        </div>
      )}
    </>
  );
};

export default Download;
